import { BackOffice } from '../BackOffice';
import { AiSettings } from './AiSettings';
import { EmailSettings } from './EmailSettings';
import { NaverNewsSettings } from './NaverNewsSettings';
import { Impersonation } from './Impersonation';
import { BackupStatusPanel } from '../../components/BackupStatusPanel';
import { StorageUsagePanel } from '../../components/StorageUsagePanel';

// =============================================================================
// H9 > 운영사 > 설정 — 운영자 · 저장 공간 · 백업 · 메일 발송 · AI 모델 · 네이버 뉴스 API · 가장 설정.
// OpsDashboard와 동일 패턴 — 자식 PageContainer의 높이/스크롤을 무력화하고
// 바깥에서 한 번만 스크롤한다.
// =============================================================================

export function OpsSettings(): JSX.Element {
  const sectionCls =
    '[&>div]:!h-auto [&>div]:!overflow-visible border-b border-line last:border-0';
  return (
    <div className="h-full overflow-auto">
      <section className={sectionCls}>
        <BackOffice />
      </section>
      <section className={sectionCls}>
        <StorageUsagePanel />
      </section>
      <section className={sectionCls}>
        <BackupStatusPanel />
      </section>
      <section className={sectionCls}>
        <EmailSettings />
      </section>
      <section className={sectionCls}>
        <AiSettings />
      </section>
      <section className={sectionCls}>
        <NaverNewsSettings />
      </section>
      <section className={sectionCls}>
        <Impersonation />
      </section>
    </div>
  );
}
